"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFees = void 0;
const constants_1 = require("../constants");
const enums_1 = require("../types/enums");
const calculateCorporateFees_1 = require("./calculateCorporateFees");
const calculateDonorFees_1 = require("./calculateDonorFees");
const calculateFees = ({ amount = 0, coverFeesParam = false, donationProvider, nonprofitCountryCode = 'US', cardCountryCode = 'US', donationPaymentMethod, isRecurring = false, feeCoveredBy = enums_1.FeeCoveredBy.User, isSandbox, applicationFeeSetting, applicationFeeAmountCap, }) => {
    if (donationPaymentMethod === enums_1.PaymentMethodType.Payroll && donationProvider === enums_1.DonationProvider.Stripe) {
        throw new Error('Payroll does not support Stripe payments');
    }
    if (donationPaymentMethod === enums_1.PaymentMethodType.CorporateDonation &&
        constants_1.DEFAULT_EXCLUDE_DONATION_PROVIDERS_CORPORATE_DONATION.includes(donationProvider)) {
        throw new Error(`CorporateDonation are not enabled for ${donationProvider} provider`);
    }
    if (donationPaymentMethod === enums_1.PaymentMethodType.CorporateDonation && feeCoveredBy === enums_1.FeeCoveredBy.User) {
        throw new Error('CorporateDonation paymentMethodType not allowed for FeeCoveredBy.User');
    }
    if (donationPaymentMethod === enums_1.PaymentMethodType.CorporateDonation && !coverFeesParam) {
        throw new Error('The coverFeesParam is not allowed to be false for CorporateDonation');
    }
    if (donationPaymentMethod === enums_1.PaymentMethodType.DeedCredit ||
        donationPaymentMethod === enums_1.PaymentMethodType.Payroll ||
        donationPaymentMethod === enums_1.PaymentMethodType.CorporateDonation) {
        return (0, calculateCorporateFees_1.calculateCorporateFees)({
            amount,
            coverFees: coverFeesParam,
            donationProvider,
            feeCoveredBy,
            applicationFeeSetting,
        });
    }
    // If it's not a corporate `donationPaymentMethod`, then it's an employee (or individual) fee
    return (0, calculateDonorFees_1.calculateDonorFees)({
        amount,
        coverFees: coverFeesParam,
        donationProvider,
        nonprofitCountryCode,
        cardCountryCode,
        isRecurring,
        feeCoveredBy,
        isSandbox,
        applicationFeeSetting,
        applicationFeeAmountCap,
    });
};
exports.calculateFees = calculateFees;
//# sourceMappingURL=calculateFees.js.map